module.exports = __webpack_public_path__ + "img/herritage.c1832958.png";